export const SUPPORT_CONFIG = {
  email: 'support@indutrust.io',
  whatsappUrl: 'https://wa.me/971501163542',
};
